module.exports = __webpack_public_path__ + "static/media/ProfillePic.89c1f3a7.png";